import { render, staticRenderFns } from "./RecommendedCourse.vue?vue&type=template&id=55b40742&scoped=true"
import script from "./RecommendedCourse.vue?vue&type=script&lang=js"
export * from "./RecommendedCourse.vue?vue&type=script&lang=js"
import style0 from "./RecommendedCourse.vue?vue&type=style&index=0&id=55b40742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b40742",
  null
  
)

export default component.exports